import React, { useEffect, useState } from 'react';
import { postAPI, fetchAPI } from '../../utils/utils';
import { formatMoney } from '../../utils/money';
import './NouPatrocinador.css';

/**
 * NouPatrocinador - Landing page that creates a Stripe checkout and redirects
 * URL: /nou-patrocinador?tier=X
 */
function NouPatrocinador() {
    const [status, setStatus] = useState('loading'); // loading, redirecting, error
    const [tierInfo, setTierInfo] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tierId = urlParams.get('tier');
        
        if (!tierId) {
            setStatus('error');
            setErrorMessage('No s\'ha especificat el tier de patrocini');
            return;
        }

        // First, get tier info to show to user while loading
        fetchAPI(`/sponsors/tiers`, (data) => {
            if (data?.success) {
                const tier = data.tiers?.find(t => t.id === parseInt(tierId));
                if (tier) {
                    setTierInfo(tier);
                }
            }
        });

        // Create checkout session and redirect
        setStatus('redirecting');
        postAPI(`/sponsors/tiers/${tierId}/generate-link`, {}, (data) => {
            if (data?.success && data.paymentLink) {
                // Redirect to Stripe checkout
                window.location.href = data.paymentLink;
            } else {
                setStatus('error');
                setErrorMessage(data?.message || 'Error creant la sessió de pagament');
            }
        }, (err) => {
            setStatus('error');
            setErrorMessage('Error de connexió amb el servidor');
        });
    }, []);

    if (status === 'error') {
        return (
            <div className="nou-patrocinador-page">
                <div className="nou-patrocinador-card error">
                    <div className="icon-container error-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                    </div>
                    <h1>Hi ha hagut un problema</h1>
                    <p className="message">{errorMessage}</p>
                    <p className="hint">
                        Si us plau, contacta amb la colla per obtenir un link de pagament vàlid.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="nou-patrocinador-page">
            <div className="nou-patrocinador-card">
                <div className="icon-container loading-icon">
                    <svg className="spinner" viewBox="0 0 50 50">
                        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="4"></circle>
                    </svg>
                </div>
                <h1>Preparant el pagament...</h1>
                {tierInfo ? (
                    <div className="tier-info">
                        <span className="tier-label">Subscripció seleccionada</span>
                        <p className="tier-name">{tierInfo.nom}</p>
                        <p className="tier-amount">{formatMoney(tierInfo.import)}€</p>
                    </div>
                ) : null}
                <p className="message">
                    T'estem redirigint a la passarel·la de pagament segura de Stripe.
                </p>
            </div>
        </div>
    );
}

export default NouPatrocinador;
